import { render, staticRenderFns } from "./CampagnaContattiList.vue?vue&type=template&id=7524e764&scoped=true&"
import script from "./CampagnaContattiList.vue?vue&type=script&lang=ts&"
export * from "./CampagnaContattiList.vue?vue&type=script&lang=ts&"
import style0 from "./CampagnaContattiList.vue?vue&type=style&index=0&id=7524e764&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7524e764",
  null
  
)

export default component.exports